import { MutationType } from '@tencent/slide-sdk-pb-model';
import { assert } from 'ts-essentials';
import { BaseMutation } from '../../base/base-mutation';
import { Rule } from '../../base/mutation-rules';
import { DataType } from '../../../data';
import type { PresentationDataModel } from '../../../model/presentation-data-model';
import type { MaybeError } from '../../base/base-mutation';
import type {
    IValidMergeTableCellsMutationData,
    IValidUnmergeTableCellsMutationData,
} from '../../base/valid-mutation-data';

export class UnMergeTableCellsMutation extends BaseMutation<
    PresentationDataModel,
    IValidUnmergeTableCellsMutationData
> {
    public readonly type: MutationType = MutationType.UnmergeTableCells;

    public apply(presentation: PresentationDataModel) {
        if (!this.data.shapeId) return;

        const { shapeId, range } = this.data;
        const table = presentation.store.models.get(shapeId, DataType.GraphicalObjectFrameTable);
        assert(table, 'table should exist');
        if (!table) return;
        table.store.unMergeTableCells(range);
    }

    public invert(): [IValidMergeTableCellsMutationData] {
        const { pageId, shapeId, range } = this.data;
        return [
            {
                type: MutationType.MergeTableCells,
                pageId,
                shapeId,
                range,
            },
        ];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { pageId, shapeId, range } = this.data;
        return Rule.every(
            Rule.shape.should.existInPage(presentation, shapeId, pageId),
            Rule.table.can.mergeTableCells(presentation, shapeId, range),
            Rule.table.range.is.singleMergedRange(presentation, shapeId, range),
        );
    }
}
